import { isMockMode, post, simulateDelay } from "../api";

export const resendActivationEmail = ({ orgId, userEmail }) => {
	if (isMockMode()) {
		const testData = { success: true };
		return simulateDelay(1000, () => testData);
	}

	return post(
		`Users/senduserregistrationreminderemail`,
		{ orgId, userEmail },
		{
			successMessage: "Email will be sent soon",
		}
	);
};
